import { useState } from 'react';
import { useAuth } from '../lib/auth.jsx';
import { useFxDefaults, saveFxDefault, fxRangeWarn } from '../lib/fxDefaults.js';
import { TZ } from '../lib/thTime.js';

const fmtWhen = v => (v ? new Date(v).toLocaleString('th-TH-u-ca-gregory-nu-latn', { timeZone: TZ, day: 'numeric', month: 'short', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');

const SYM = { JPY: '¥', USD: '$', EUR: '€', GBP: '£', CNY: '¥' };

// แถบ "เรทค่าเงินกลาง" — ดู/แก้ได้ในที่เดียว ใบที่ยังไม่มีเรทจะใช้ค่านี้
export default function FxDefaultsBar({ highlight }) {
  const { profile } = useAuth();
  const table = useFxDefaults();
  const [edit, setEdit] = useState(false);
  const [draft, setDraft] = useState({});
  const [newCur, setNewCur] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const rows = Object.entries(table ?? {}).filter(([k]) => k !== '__meta').sort(([a], [b]) => a.localeCompare(b));
  const meta = table?.__meta ?? {};
  const last = rows.map(([c]) => meta[c]).filter(Boolean)
    .sort((a, b) => String(b.updated_at).localeCompare(String(a.updated_at)))[0];

  function start() {
    setDraft(Object.fromEntries(rows.map(([c, r]) => [c, String(r)])));
    setNewCur(''); setErr(''); setEdit(true);
  }
  async function save() {
    setBusy(true); setErr('');
    try {
      const odd = Object.entries(draft).map(([c, v]) => fxRangeWarn(c, v)).filter(Boolean);
      if (odd.length && !window.confirm(odd.join('\n') + '\n\nบันทึกเป็นเรทกลางจริงหรือไม่? (ใบที่ยังไม่มีเรทจะใช้ค่านี้)')) { setBusy(false); return; }
      const who = profile?.full_name || 'BUY';
      for (const [c, v] of Object.entries(draft)) {
        if (String(table?.[c] ?? '') !== String(v).trim()) await saveFxDefault(c, v, who);
      }
      setEdit(false);
    } catch (e) { setErr(e.message ?? String(e)); }
    finally { setBusy(false); }
  }
  function addCur() {
    const c = newCur.toUpperCase().trim();
    if (!/^[A-Z]{3}$/.test(c) || c === 'THB' || draft[c] != null) return;
    setDraft(d => ({ ...d, [c]: '' })); setNewCur('');
  }

  return (
    <div className={`fxd-bar${highlight ? ' hl' : ''}`}>
      <span className="fxd-title">เรทค่าเงินกลาง <span className="en">Default FX → THB</span></span>
      {!edit ? (
        <>
          <span className="fxd-list">
            {rows.length === 0 && <span className="sd-empty" style={{ margin: 0 }}>ยังไม่ได้ตั้ง</span>}
            {rows.map(([c, r]) => (
              <span key={c} className={`fxd-chip${highlight === c ? ' on' : ''}`}>
                <b>{SYM[c] ?? ''}1 {c}</b> = ฿{r}
              </span>
            ))}
          </span>
          <button className="fxd-btn" onClick={start}>แก้เรทกลาง</button>
          {last && <span className="fxd-meta">แก้ล่าสุด {fmtWhen(last.updated_at)}{last.updated_by ? ` · ${last.updated_by}` : ''}</span>}
        </>
      ) : (
        <>
          <span className="fxd-list">
            {Object.entries(draft).map(([c, v]) => (
              <label key={c} className="fxd-edit">
                <b>{c}</b>
                <input className="under mono" inputMode="decimal" value={v} autoFocus={c === highlight}
                       onChange={e => setDraft(d => ({ ...d, [c]: e.target.value.replace(/[^0-9.]/g, '') }))} />
              </label>
            ))}
            <label className="fxd-edit add">
              <input className="under mono" placeholder="+ สกุลอื่น เช่น EUR" maxLength={3} value={newCur}
                     onChange={e => setNewCur(e.target.value.toUpperCase().replace(/[^A-Z]/g, ''))}
                     onKeyDown={e => { if (e.key === 'Enter') addCur(); }} />
              {newCur.length === 3 && <button className="fxd-btn" onClick={addCur}>เพิ่ม</button>}
            </label>
          </span>
          <button className="fxd-btn solid" onClick={save} disabled={busy}>{busy ? 'กำลังบันทึก…' : 'บันทึก'}</button>
          <button className="fxd-btn" onClick={() => { setEdit(false); setErr(''); }} disabled={busy}>ยกเลิก</button>
        </>
      )}
      {err && <span className="fxd-err">{err}</span>}
    </div>
  );
}
